import * as React from "react";
import { SVGProps } from "react";
const SvgLightbulbIdea = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 27v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2h8ZM16 7a8 8 0 0 1 8 8c0 4.207-4.004 5.793-4.004 10h-8C11.996 20.795 8 19.205 8 15a8 8 0 0 1 8-8Zm2.121 5.464L16 14.586l-2.122-2.122-1.414 1.414L15 16.414V20h2v-3.586l2.535-2.536-1.414-1.414ZM4 14a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2h2Zm26 0a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2h2ZM6.808 4.394l1.414 1.414a1 1 0 0 1-1.414 1.414L5.394 5.808a1 1 0 0 1 1.414-1.414Zm19.798 0a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 1 1-1.414-1.414l1.414-1.414a1 1 0 0 1 1.414 0ZM16 0a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLightbulbIdea;
